import { useEffect, useState, useRef } from "react";

function LazyLoad({ children }) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "100px" } // preload slightly before visible
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="markets-item__title-row" ref={ref}>
      {isVisible ? children : null}
    </div>
  );
}

export default LazyLoad;
